import { observer } from 'mobx-react';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { AnalyticsTrigger, Collapse, CollapseProvider, CollapseTrigger, List, Separator, Text, CollapseToggle, Notice, scrollToElement, useTheme } from 'telia-front-react';
import TradeInConditionBulletpoint from './TradeInConditionBulletpoint';
const TradeInConditionsBulletpoints = ({ condition, conditionKey, tradeInStore: { getConditionBulletPoints, questionsClosed }, translate, tradeInStore }) => {
    const { media } = useTheme();
    const isMinWidthSm = useMediaQuery({ minWidth: media.width.sm.min });
    return (React.createElement(AnalyticsTrigger, { trigger: { id: `Link - Trade-in condition ${condition} - Loen lähemalt`, callback: 'onToggle' } },
        React.createElement(CollapseProvider, { id: `${condition}-collapse-provider`, isVisible: !questionsClosed.has(conditionKey), onToggle: (visible) => {
                if (visible) {
                    questionsClosed.delete(conditionKey);
                }
                else {
                    questionsClosed.add(conditionKey);
                    const offset = isMinWidthSm ? 40 + 120 : 20 + 112;
                    setTimeout(() => {
                        if (!!document.getElementById(`card-counter-${conditionKey}`)) {
                            scrollToElement(`card-counter-${conditionKey}`, 500, offset);
                        }
                    }, 200);
                }
            } },
            React.createElement(Collapse, { initialVisibleHeight: 0, noContainer: true, color: "grey" },
                React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                React.createElement(Text, null,
                    React.createElement(Notice, null, translate('tradeIn.conditions.bulletPoints.condition')),
                    React.createElement(List, { fullWidth: true }, getConditionBulletPoints(condition).map((bulletPointLabel, i, bulletPoints) => (React.createElement(TradeInConditionBulletpoint, { key: `${condition}-${i}`, tradeInStore: tradeInStore, label: bulletPointLabel, bulletPointNr: i + 1, isLast: i === bulletPoints.length - 1, condition: condition, translate: translate })))))),
            React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
            React.createElement(CollapseTrigger, null,
                React.createElement(CollapseToggle, { text: `${translate('tradeIn.conditions.bulletPoints.readMore')}`, activeText: `${translate('tradeIn.conditions.bulletPoints.readLess')}`, iconRight: "#arrow-down", link: true })))));
};
export default observer(TradeInConditionsBulletpoints);
